import { render, staticRenderFns } from "./WebsitePageHtmlTemplateForm.vue?vue&type=template&id=56d7296e&scoped=true&"
import script from "./WebsitePageHtmlTemplateForm.vue?vue&type=script&lang=js&"
export * from "./WebsitePageHtmlTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7296e",
  null
  
)

export default component.exports